export default {"src":"/_next/static/media/arrow-left-swiper.fdddc3ee.svg","height":21,"width":26,"blurWidth":0,"blurHeight":0};